/* rola.pet — tryb quizu dla kalkulatorów (karmienie, wiek, waga i wielkość psa, sucha masa karmy).
   Nakładka na rola-calc.js: NIE zmienia obliczeń ani pól formularza,
   tylko pokazuje pytania po jednym (karty "Dalej / Wstecz") i wynik na końcu.
   Włączana ustawieniem sekcji: data-quiz="true" na elemencie [data-rc-scope]. */
(function(){
  "use strict";

  function attr(el, name, fallback){
    var v = el.getAttribute(name);
    return v ? v : fallback;
  }

  function numVal(el){
    var v = parseFloat(String(el.value).replace(",", ".").replace(/\s/g, ""));
    return isNaN(v) ? null : v;
  }

  /* zwraca true, gdy kwiz gotowy (lub nie dotyczy); false, gdy kalkulator jeszcze się nie zbudował */
  function setup(scope){
    var root = scope.querySelector("[data-rola-dog-food], [data-rola-dog-age], [data-rola-dog-growth], [data-rola-dog-drymatter]");
    if(!root) return true;
    var card = root.querySelector(".rc-card");
    var feedsHost = root.querySelector("[data-feeds]");
    var demand = root.querySelector("[data-demand]");
    if(!card) return true;
    /* kalkulator karmienia buduje karty JS-em po DOMContentLoaded — czekamy, aż będą gotowe */
    if(feedsHost && !feedsHost.querySelector(".rc-opt")) return false;

    var L = {
      next:    attr(scope, "data-quiz-next", "Dalej"),
      back:    attr(scope, "data-quiz-back", "Wstecz"),
      finish:  attr(scope, "data-quiz-finish", "Pokaż wynik"),
      progress:attr(scope, "data-quiz-progress", "Krok {i} z {n}"),
      edit:    attr(scope, "data-quiz-edit", "Zmień odpowiedzi"),
      restart: attr(scope, "data-quiz-restart", "Zacznij od nowa")
    };
    var auto = scope.getAttribute("data-quiz-auto") !== "false";

    /* kroki = bezpośrednie dzieci karty (pytania + opcjonalny koszt) */
    var steps = Array.prototype.filter.call(card.children, function(el){
      return el.classList.contains("rc-step") || el.classList.contains("rc-acc--inline");
    });
    if(!steps.length) return true;

    var feedStep = feedsHost ? feedsHost.closest(".rc-step") : null;
    var current = null;
    var timer = null;
    var lastPointer = 0;

    /* --- przygotowanie kroków --- */
    steps.forEach(function(s){
      if(s.tagName === "DETAILS"){
        s.open = true; /* koszt: otwarty na stałe, jako zwykły krok */
        var sm = s.querySelector("summary");
        if(sm){
          sm.setAttribute("tabindex", "-1");
          sm.addEventListener("click", function(e){ e.preventDefault(); });
        }
        return;
      }
      /* numeracja "1 ·", "2 ·" zastępuje pasek postępu (kroki bywają pomijane) */
      var label = s.querySelector(".rc-label");
      var n = label && label.firstChild;
      if(n && n.nodeType === 3) n.nodeValue = n.nodeValue.replace(/^\s*\d+\s*\u00b7\s*/, "");
    });

    /* --- UI: pasek postępu --- */
    var progress = document.createElement("div");
    progress.className = "rq-progress";
    var progTxt = document.createElement("span");
    progTxt.className = "rq-progress-txt";
    progTxt.setAttribute("aria-live", "polite");
    var bar = document.createElement("div");
    bar.className = "rq-bar";
    var fill = document.createElement("span");
    fill.className = "rq-bar-fill";
    bar.appendChild(fill);
    progress.appendChild(progTxt);
    progress.appendChild(bar);
    card.insertBefore(progress, card.firstChild);

    /* --- UI: nawigacja --- */
    var err = document.createElement("p");
    err.className = "rq-err";
    err.setAttribute("role", "alert");
    err.hidden = true;

    var nav = document.createElement("div");
    nav.className = "rq-nav";
    var backBtn = document.createElement("button");
    backBtn.type = "button";
    backBtn.className = "rq-btn rq-back";
    backBtn.textContent = "\u2190 " + L.back;
    var nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.className = "rq-btn rq-btn--primary rq-next";
    nav.appendChild(backBtn);
    nav.appendChild(nextBtn);
    card.appendChild(err);
    card.appendChild(nav);

    /* --- UI: pasek nad wynikiem --- */
    var resultBar = document.createElement("div");
    resultBar.className = "rq-resultbar";
    var editBtn = document.createElement("button");
    editBtn.type = "button";
    editBtn.className = "rq-btn";
    editBtn.textContent = "\u2190 " + L.edit;
    var restartBtn = document.createElement("button");
    restartBtn.type = "button";
    restartBtn.className = "rq-btn";
    restartBtn.textContent = "\u21bb " + L.restart;
    resultBar.appendChild(editBtn);
    resultBar.appendChild(restartBtn);
    card.parentNode.insertBefore(resultBar, card.nextSibling);

    /* --- logika kroków --- */
    function active(){
      var list = steps.filter(function(el){ return !el.hidden; });
      /* "wszystkie trzy" = panel zapotrzebowania zamiast wyniku → kończymy na kroku wyboru karmienia */
      if(demand && !demand.hidden && feedStep){
        var i = list.indexOf(feedStep);
        if(i !== -1) list = list.slice(0, i + 1);
      }
      return list;
    }

    function paint(){
      var list = active();
      var i = list.indexOf(current);
      if(i === -1){ i = 0; current = list[0]; }
      steps.forEach(function(s){ s.classList.toggle("is-current", s === current); });
      var last = i === list.length - 1;
      progTxt.textContent = L.progress.replace("{i}", i + 1).replace("{n}", list.length);
      fill.style.width = ((i + 1) / list.length * 100).toFixed(1) + "%";
      backBtn.classList.toggle("is-off", i === 0);
      nextBtn.textContent = last ? L.finish : L.next + " \u2192";
    }

    function toTop(){
      var r = root.getBoundingClientRect();
      if(r.top < 0 || r.top > window.innerHeight * 0.6){
        var rm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: window.pageYOffset + r.top - 100, behavior: rm ? "auto" : "smooth" });
      }
    }

    function clearErr(){ err.hidden = true; err.textContent = ""; }
    function fail(msg, el){
      err.textContent = msg;
      err.hidden = false;
      if(el && el.focus) el.focus();
      return false;
    }

    function unitFor(f){
      if(f.hasAttribute("data-in-bag")) return "kg";
      if(f.hasAttribute("data-in-price")) return "z\u0142";
      return "kcal / 100 g";
    }
    function rangeMsg(f){
      return "Podaj wartość od " + f.getAttribute("min") + " do " + f.getAttribute("max") + " " + unitFor(f) + ".";
    }

    function validate(step){
      clearErr();
      if(typeof step.rqValidate === "function"){
        var custom = step.rqValidate();
        if(custom !== true) return fail(custom.msg, custom.el);
      }
      var wnum = step.querySelector("[data-in-weight-num]");
      if(wnum){
        var w = numVal(wnum);
        if(w === null || w < 1 || w > 80) return fail("Podaj wagę psa w zakresie od 1 do 80 kg.", wnum);
        wnum.dispatchEvent(new Event("blur")); /* normalizacja przez rola-calc.js */
      }
      var anum = step.querySelector("[data-in-age-num]");
      if(anum){
        var a = numVal(anum);
        if(a === null || a < 0.5 || a > 20) return fail("Podaj wiek psa w zakresie od 0,5 do 20 lat.", anum);
        anum.dispatchEvent(new Event("blur"));
      }
      var fields = step.querySelectorAll("[data-in-kcal],[data-in-kcal-wet],[data-in-kcal-home],[data-in-bag],[data-in-price]");
      for(var i = 0; i < fields.length; i++){
        var f = fields[i];
        var wrap = f.closest("[data-need]");
        if(wrap && wrap.hidden) continue;
        var optional = f.hasAttribute("data-in-kcal-home") || f.hasAttribute("data-in-bag") || f.hasAttribute("data-in-price");
        if(String(f.value).trim() === ""){
          if(optional) continue;
          return fail(rangeMsg(f), f);
        }
        var v = numVal(f);
        var mn = parseFloat(f.getAttribute("min")), mx = parseFloat(f.getAttribute("max"));
        if(v === null || (!isNaN(mn) && v < mn) || (!isNaN(mx) && v > mx)) return fail(rangeMsg(f), f);
      }
      return true;
    }

    function show(el){
      clearTimeout(timer);
      clearErr();
      current = el;
      paint();
      var r = root.getBoundingClientRect();
      if(r.top < 0) toTop();
    }

    function finish(){
      clearErr();
      scope.classList.add("rq-done");
      if(window.dataLayer) window.dataLayer.push({ event: "rola_calc_quiz_complete", rola_feature: root.hasAttribute("data-rola-dog-drymatter") ? "drymatter_calculator" : (root.hasAttribute("data-rola-dog-growth") ? "growth_calculator" : (root.hasAttribute("data-rola-dog-age") ? "age_calculator" : "feeding_calculator")) });
      requestAnimationFrame(toTop);
    }

    function next(){
      var list = active();
      var i = list.indexOf(current);
      if(i === -1) return;
      if(!validate(current)) return;
      if(i < list.length - 1) show(list[i + 1]);
      else finish();
    }

    function back(){
      var list = active();
      var i = list.indexOf(current);
      if(i > 0) show(list[i - 1]);
    }

    nextBtn.addEventListener("click", next);
    backBtn.addEventListener("click", back);

    editBtn.addEventListener("click", function(){
      scope.classList.remove("rq-done");
      var list = active();
      current = list[list.length - 1];
      paint();
      requestAnimationFrame(toTop);
    });
    scope.addEventListener("rq:restart", function(){ restartBtn.click(); });
    scope.addEventListener("rq:next", function(){ nextBtn.click(); });
    restartBtn.addEventListener("click", function(){
      scope.classList.remove("rq-done");
      current = active()[0];
      paint();
      requestAnimationFrame(toTop);
    });

    /* po każdej zmianie odpowiedzi rola-calc.js już przeliczył widoczność kroków — odświeżamy pasek */
    card.addEventListener("pointerdown", function(){ lastPointer = Date.now(); });
    card.addEventListener("input", function(){ clearErr(); paint(); });
    card.addEventListener("change", function(e){
      clearErr();
      paint();
      var t = e.target;
      /* auto-przejście tylko po kliknięciu/tapnięciu karty (nie przy nawigacji strzałkami) */
      if(auto && t && t.type === "radio" && current && current.contains(t) && !current.hasAttribute("data-rq-noauto") && Date.now() - lastPointer < 800){
        var at = current;
        clearTimeout(timer);
        timer = setTimeout(function(){
          if(current === at && !scope.classList.contains("rq-done")) next();
        }, 320);
      }
    });

    /* Enter w polu liczbowym = "Dalej" */
    card.addEventListener("keydown", function(e){
      var t = e.target;
      if(e.defaultPrevented) return; /* np. Enter w liście ras już wybrał rasę */
      if(e.key === "Enter" && t && t.tagName === "INPUT" && (t.type === "text" || t.type === "number")){
        e.preventDefault();
        next();
      }
    });

    scope.classList.add("rq-on");
    current = active()[0];
    paint();
    scope.setAttribute("data-rq-init", "1");
    return true;
  }

  var tries = 0;
  function boot(){
    var scopes = document.querySelectorAll('[data-rc-scope][data-quiz="true"]');
    var pending = false;
    for(var i = 0; i < scopes.length; i++){
      if(scopes[i].getAttribute("data-rq-init")) continue;
      if(setup(scopes[i]) === false) pending = true;
    }
    /* rola-calc.js buduje karty po DOMContentLoaded — gdyby nie zdążył, próbujemy ponownie */
    if(pending && tries++ < 40) setTimeout(boot, 50);
  }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
